export const CONSULTANT_DOCTOR = [
  'AGG',
  'AMT',
  'BOD',
  'COC',
  'CRW',
  'FIR',
  'HPR',
  'DEE',
  'NEM',
  'PRV',
  'RPV',
]

export const OUTCOME = [
  'severe',
  'non-severe',
  'unknown',
  'SEV',
  'NSV',
  'UNK',
]

export const OUTCOME_TYPE = [
  'AMT',
  'ATM',
  'DCI',
  'DNT',
  'FSN',
  'ICE',
  'DEE',
  'PID',
]
